export function generateSafeAccessor(accessor) {
  if (typeof accessor === 'string') {
    function s(d) {
      try {
        return d[accessor];
      } catch {
        return 0;
      }
    }
    return s;
  } else if (typeof accessor === 'number') {
    function s(d) {
      try {
        return d[accessor];
      } catch {
        return 0;
      }
    }
    return s;
  }
  function s(d) {
    try {
      return accessor instanceof Function ? accessor(d) : 0;
    } catch {
      return 0;
    }
  }
  return s;
}

// TODO: Make typescript play correctly with multiple args
export function useSafeAccessors() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.map(d => generateSafeAccessor(d));
}
export function getX(l) {
  return typeof (l === null || l === void 0 ? void 0 : l.x) === 'number' ? l === null || l === void 0 ? void 0 : l.x : 0;
}
export function getY(l) {
  return typeof (l === null || l === void 0 ? void 0 : l.y) === 'number' ? l === null || l === void 0 ? void 0 : l.y : 0;
}
export function getSource(l) {
  return l === null || l === void 0 ? void 0 : l.source;
}
export function getTarget(l) {
  return l === null || l === void 0 ? void 0 : l.target;
}
export function getFirstItem(d) {
  return d === null || d === void 0 ? void 0 : d[0];
}
export function getSecondItem(d) {
  return d === null || d === void 0 ? void 0 : d[1];
}